export enum Locales {
  en = 'en',
  ar = 'ar',
}
